export default __webpack_public_path__ + "static/media/Top_Doc_Logos-Group.99cf2630.jpg";